// The open project's issued estimates and change orders (estimates.list), loaded again whenever one is issued.
import { useEffect, useState } from './react.js';
import { API } from './api.js';

export const ISSUED_EVENT = 'prism-estimate-saved';
export function useIssued(project) {
  const [docs, setDocs] = useState(null);
  const id = project?.id;
  useEffect(() => {
    if (!id) { setDocs([]); return; }
    let live = true;
    const load = () => API.call('estimates.list', { projectId: id }).then(r => { if (live) setDocs(r.estimates); }).catch(() => { if (live) setDocs(d => d || []); });
    setDocs(null); load();
    window.addEventListener(ISSUED_EVENT, load);
    return () => { live = false; window.removeEventListener(ISSUED_EVENT, load); };
  }, [id]);
  return docs;
}
